import { Component } from '@angular/core';
import { DialogBaseComponent } from './dialog_base.component';
import { InstallAutomaticallyComponent } from './install_automatically.component';
import { ManualSetupState } from '../main/manual_setup/store/manual_setup_state';
import { Store } from '@ngrx/store';
import { RedirectService } from '../../../shared/services/redirect.service';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { IAppState } from '../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-integrate-install-automatically-approval-dialog',
  template: require('./install_automatically_approval.component.html'),
  styles: [require('./install_automatically_approval.component.scss')]
})
export class InstallAutomaticallyApprovalComponent extends DialogBaseComponent {
  private nextComponent = InstallAutomaticallyComponent;
  private productLiquid = null;
  private redirectService;

  constructor(redCrossService: AnalyticsTrackingProvider,
              store: Store<IAppState>,
              redirectService: RedirectService) {
    super('Install Automatically', redCrossService);

    this.redirectService = redirectService;
    store.select(state => state.app.install.manualSetup).subscribe(
      (items: ManualSetupState) => {
        for (let item of items.accordionItems) {
          if (item.data.productLiquid) {
            this.productLiquid = item.data.productLiquid;
            break;
          }
        }
      }
    );
  }

  openTemplate() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'product.liquid template'
    });
    this.redirectService.redirectTo(this.productLiquid, true);
  };

  moveToNextDialog() {
    this.nextDialog.emit(this.nextComponent);
  }
}




